module.exports = __webpack_public_path__ + "img/main_banner.f80e8520.jpg";